// Función para limpiar los escudos de torneos antiguos
export const clearOldTournamentShields = (currentTournamentId) => {
  // Obtener todas las claves del localStorage
  const keys = Object.keys(localStorage);
  
  // Filtrar las claves que contienen "-images" y no corresponden al torneo actual
  const oldShieldKeys = keys.filter(key => 
    key.includes("-images") && 
    !key.includes(currentTournamentId)
  );
  
  // Eliminar las claves antiguas
  oldShieldKeys.forEach(key => {
    console.log(`Eliminando escudos antiguos: ${key}`);
    localStorage.removeItem(key);
  });
};

// Función para guardar los escudos de un torneo
export const saveTournamentShields = (tournamentId, images) => {
  // Primero limpiar escudos antiguos
  clearOldTournamentShields(tournamentId);
  
  // Luego guardar los nuevos escudos
  localStorage.setItem(`${tournamentId}-images`, JSON.stringify(images));
};

/**
 * Añade o actualiza un escudo en la caché local del torneo (misma clave que usan grupos/partidos/bracket).
 * No borra el resto de equipos del torneo.
 */
export function mergeTournamentTeamImage(tournamentId, teamId, imageData) {
  if (!tournamentId || !teamId || !imageData) return;
  const key = `${tournamentId}-images`;
  let arr = [];
  try {
    const raw = localStorage.getItem(key);
    if (raw) arr = JSON.parse(raw);
  } catch {
    arr = [];
  }
  if (!Array.isArray(arr)) arr = [];
  const next = arr.filter((x) => x && x.id !== teamId);
  next.push({ id: teamId, imageData });
  localStorage.setItem(key, JSON.stringify(next));
} 